import { createContext, useContext } from 'react';
/** The theme `ThemeProvider` applies; light outside a provider, matching the page's default tokens. */
export const ThemeContext = createContext('light');
/**
 * Reads the theme the nearest `ThemeProvider` applies, for a part that must be told its theme rather than read it from
 * the design tokens (for example a third-party button drawn in an iframe).
 *
 * Takes no parameters.
 *
 * @returns `'light'` or `'dark'`, following the system setting live: the caller re-renders when it changes. Outside a
 * `ThemeProvider` it is always `'light'`, the theme the tokens fall back to.
 */
export function useTheme() {
    return useContext(ThemeContext);
}
//# sourceMappingURL=useTheme.js.map